import { SupplyChainManagementComponent } from 'src/modules/inventory-management/components/supply-chain-management/supply-chain-management.component';
import { SaPurchaseRequestComponent } from 'src/modules/inventory-management/components/sa-purchase-request/sa-purchase-request.component';

export const inventoryRouteDef = [
    {
        path: 'config/scm/scm-config',
        component: 'ScmConfigsComponent',
        data: {
            selector: 'app-scm-configs'
        }
     },
    {
        path: 'directRecieveMaster/:receiptNo',
    },
    {
        path: 'purchase/requisition',
        component: 'SupplyChainManagementComponent',
        data: {
            selector: 'app-supply-chain-management',
            resource: 'purchase_request',
            action: 'add'
        }
    },
    {
        path: 'sa_purchase/requisition',
        component: 'SaPurchaseRequestComponent',
        data: {
            selector: 'app-sa-purchase-request',
            resource: 'sa_purchase_request',
            action: 'add'
        }
    },
    {
        path: 'bulk_stock_adjustment',
        component: 'BulkStockAdjustmentComponent',
        data: {
            selector: 'app-bulk-stock-adjustment',
            resource: 'bulk_stock_adjustment',
            action: 'add'
        }
    },
    {
        path: 'central_indent_approved/:id/view',
        component: 'ApproveIndentComponent',
        data: {
            selector: 'app-approve-indent',
            resource:'central_indent_approved',
            input:'central_indent_approved',
            action: 'VIEW'
        }
    },
    {
        path: 'indent/ackRejectRecieveIndent',
        component: 'AcknowledgeRejectRecieveIndentComponent',
        data: {
            selector: 'app-acknowledge-reject-recieve-indent',
            resource: 'central_received_indent_issued',
            input: 'central_received_indent_issued',
            action: 'Add'
        }
    },
    {
        path: 'inventoryDirectIssue/acknowledge_receipt',
        component: 'DirectIssueReceiveComponent',
        data: {
            selector: 'app-direct-issue-receive',
            resource: 'inventory_direct_issue_receipt',
            input: 'inventory_direct_issue_receipt',
            action: 'Add'
        }
    },
    {
        path: 'indent/ackRejectInitiatedItem',
        component: 'RejectInitiatedAcknowledgeComponent',
        data: {
            selector: 'app-reject-initiated-acknowledge',
            resource: 'rej_ini_issuedIndent',
            input: 'rej_ini_issuedIndent',
            action: 'Add'
        }
    },
    {
        path: 'rej_ini_issuedIndent/:id/view',
        component: 'UiEngineComponent',
        data: {
            selector:  'app-ui-engine',
            resource: 'rej_ini_issuedIndent',
            action: "VIEW",
        }
    },
    {
        path: 'ack_reject_return_indent/:id/view',
        component: 'UiEngineComponent',
        data: {
            selector:  'app-ui-engine',
            resource: 'ack_reject_return_indent',
            action: "VIEW",
        }
    },
    {
        path: 'indent/ini_return_reject',
        component: 'RejectReturnIndentComponent',
        data: {
            selector: 'app-reject-return-indent',
            resource: 'reject_return_indent',
            input: 'reject_return_indent',
            action: 'Add'
        }
    },
    {
        path: 'indent/approve_return_reject',
        component: 'RejectReturnIndentComponent',
        data: {
            selector: 'app-reject-return-indent',
            resource: 'reject_return_indent',
            input: 'reject_return_indent',
            action: 'Add'
        }
    },

    {
        path: 'indent/approveIndent',
        component: 'ApproveIndentComponent',
        data: {
            selector: 'app-approve-indent',
            resource: 'central_indent_approved',
            action: 'add'
        }
    },
    {
        path: 'indent/InterfacilityApproveIndentL1',
        component: 'ApproveIndentComponent',
        data: {
            selector: 'app-approve-indent',
            resource: 'l1_approve_interfacility_indent',
            action: 'add'
        }
    },
    {
        path: 'indent/InterfacilityApproveIndent',
        component: 'ApproveIndentComponent',
        data: {
            selector: 'app-approve-indent',
            resource: 'approve_interfacility_indent',
            action: 'add'
        }
    },
    {
        path: 'indent/InterfacilityApproveHODIndent',
        component: 'ApproveIndentComponent',
        data: {
            selector: 'app-approve-indent',
            resource: 'approve_interfacility_indent',
            action: 'add'
        }
    },
    {
        path: 'indent/approveHODIndent',
        component: 'ApproveIndentComponent',
        data: {
            selector: 'app-approve-indent',
            resource: 'central_indent_approved',
            action: 'add'
        }
    },
    {
        path: 'indent/pendingindentissue',
        component: 'PendingIndentIssueComponent',
        data: {
            selector: 'app-pending-indent-issue',
            resource: 'indent_issue_add',
            action: 'add'
        }
    },
    {
        path: 'indent/pendingindentreject',
        component: 'PendingIndentRejectComponent',
        data: {
            selector: 'app-pending-indent-reject',
            resource: 'indent_reject_add',
            action: 'add'
        }
    },
    {
        path: 'interfacilityIndent/interfacility_indent_issue_add',
        component: 'InterfacilityPendingIndentIssueComponent',
        data: {
            selector: 'app-interfacility-pending-indent-issue',
            resource: 'interfacility_indent_issue_add',
            action: 'add'
        }
    },
    {
        path: 'interfacilitySaleIndent/interfacility_sale_indent_issue_add',
        component: 'InterfacilityPendingIndentIssueComponent',
        data: {
            selector: 'app-interfacility-pending-indent-issue',
            resource: 'interfacility_sale_indent_issue_add',
            action: 'add'
        }
    },
    {
        path: 'physicalStockDetails/stock',
        component: 'PhysicalStockDetailsComponent',
        data: {
            selector: 'app-physical-stock-details',
            resource: 'physicalStockDetails',
            action: 'add'
        }
    },
    {
        path: 'physicalStockDetailsViewDetails/stock',
        component: 'PhysicalStockDetailsComponent',
        data: {
            selector: 'app-physical-stock-details',
            resource: 'physical_stock_details_view',
            action: 'view'
        }
    },
    
    {
        path: 'rate_contract_comparision_list/rate_comparision',
        component: 'RateContractComparisionComponent',
        data: {
            selector: 'app-rate-contract-comparision',
            resource: 'rate_contract_comparision',
            action: 'ADD'
        }
    },
    {
        path: 'purchase/requisition/modify',
        component: 'SupplyChainManagementComponent',
        data: {
            selector: 'app-supply-chain-management',
            resource: 'purchase_request',
            action: 'modify'
        }
    },
    {
        path: 'purchase/requisition/view',
        component: 'SupplyChainManagementComponent',
        data: {
            selector: 'app-supply-chain-management',
            resource: 'purchase_request',
            action: 'VIEW'
        }
    },
    {
        path: 'sa_purchase/requisition/modify',
        component: 'SaPurchaseRequestComponent',
        data: {
            selector: 'app-sa-purchase-request',
            resource: 'sa_purchase_request',
            action: 'modify'
        }
    },
    {
        path: 'sa_purchase/requisition/view',
        component: 'SaPurchaseRequestComponent',
        data: {
            selector: 'app-sa-purchase-request',
            resource: 'sa_purchase_request',
            action: 'VIEW'
        }
    },
    {
        path: ':id/stock_update_qty/updateStock',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'stock_update_qty',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/con_stock_update_qty/conUpdateStock',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'con_stock_update_qty',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/reusable_stock_condemn/add',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'reusable_stock_condemn',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/reusable_stock_update_qty/updateStock',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'reusable_stock_update_qty',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/scm_grnMaster_approve_reject/approve_reject',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'scm_grnMaster_approve_reject',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/scm_grnMaster_approve_reject/rejectOnly',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'scm_grnMaster_rejectOnly',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/sa_grn_master_approve_reject/approve_reject',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'sa_grn_master_approve_reject',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/sa_grn_master_approve_reject/rejectOnly',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'sa_grn_master_reject',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/grnReturn_approve/approve',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'grnReturn_approve',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/grnReturn_reject/reject',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'grnReturn_reject',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/consignment_create_grn/create_consginement',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'consignment_create_grn',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/sa_purchase_order_approval/approve_purchase_order',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'sa_purchase_order_approval_detail',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/sa_purchase_order_approval/approve_purchase_order_remodify',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'sa_purchase_order_approval_detail_remodify',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/purchase_order_approval/approve_purchase_order',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'purchase_order_approval_detail',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/purchase_order_approval/approve_purchase_order_remodify',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'purchase_order_approval_detail_remodify',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/:resource/review',
        component: 'ReviewOrderModalComponent',
        data: {
            selector: 'kx-review-order-modal'
        }
    },
    {
        path: ':resource/scmOrderList',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            action: "LIST",
            decorator: "my_orders_format",
            resource: "consumer_order_format",
        }
    },
    {
        path: ':resource/:orderId/scmOrder',
        component: 'ScmOrderDetalComponent',
        data: {
            selector: 'app-scm-order-detal',
            action: "LIST",
        }
    },
    {
        path: ':id/stock_update_batch/updateBatch',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'stock_update_batch',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/stock_update_batch/updateExpiry',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'stock_update_expiry',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/stock_update_batch/updateMRP',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'stock_update_mrp',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/con_stock_update_batch/conUpdateBatch',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'con_stock_update_batch',
            action: 'MODIFY',
        }
    },
    {
        path: 'rate_contract_comparision_list/comparision_list',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'rate_contract_comparision_list',
            action: 'LIST',
        }
    },
    {
        path: ':id/supplier_item_rc_update/updateRateContract',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'supplier_item_rc_update',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/supplier_item_rc_update/viewRateContract',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'supplier_item_rc_update',
            action: 'VIEW',
        }
    },
    {
        path: 'whitelist_mac/:id',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'whitelist_mac',
            action: 'FORM_GRID',
        }
    },
    {
        path: 'citizen_item/item_cart/add',
        component: 'CitizenCartComponent',
        data: {
            selector: 'app-citizen-cart',
            type: 'request'
        }
    },
    {
        path: 'supplier_item/item_cart/add',
        component: 'SupplierCartComponent',
        data: {
            selector: 'app-supplier-cart',
            type: 'request'
        }
    },
    {
        path: 'citizen_item/acknowledge_item',
        component: 'CitizenCartComponent',
        data: {
            selector: 'app-citizen-cart',
            type: 'acknowledge'
        }
    },
    {
        path: 'citizen_item/acknowledge_item/:action',
        component: 'CitizenCartComponent',
        data: {
            selector: 'app-citizen-cart',
            type: 'acknowledge'
        }
    },
    {
        path: 'update_cn_value/cnValue/:id',
        component: 'UpdateCNValueComponent',
        data: {
            selector: 'app-update-cnvalue',
            resource: 'ipMedicationOrder',
            action: 'UPDATE',
        }
    },
    {
        path: 'itemOpticalLayout/list',
        component: 'UiEngineComponent',
        data: {
            selector:  'app-ui-engine',
            resource: 'itemOpticalLayout',
            action: "LIST",
        }
     },
     {
        path: 'bulk_stock_adjustment/add',
        component: 'BulkStockAdjustmentComponent',
        data: {
            selector: 'app-bulk-stock-adjustment',
            resource: 'bulk_stock_adjustment',
            action: 'Add',
        }
    },
    {
        path: 'stock_adjustment_detail_view/stock',
        component: 'BulkStockAdjustmentComponent',
        data: {
            selector: 'app-bulk-stock-adjustment',
            resource: 'stock_adjustment_detail_view',
            action: 'view'
        }
    },
    {
        path: ':id/:resource',
        component: 'IndentIssueComponent',
        data: {
            selector: 'app-indent-issue'
        }
    },
    {
        path: ':id/service_agreement_rc_update/updateRateContract',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'service_agreement_rc_update',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/service_agreement_rc_update/viewRateContract',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'service_agreement_rc_update',
            action: 'VIEW',
        }
    },
    {
        path: ':id/grnReadOnly/viewApprove',
        component: 'GrnReadOnlyViewApproveComponent',
        data: {
            selector: 'app-grn-read-only-view-approve',
            resource: 'scm_grnMaster',
            action: 'VIEW',
        }
    }
]
